export const ZERO_VIEW_TYPE = {
  SERVICE_NOT_AVAILABLE: 'SERVICE_NOT_AVAILABLE',
  LOAN_APPLICATION_POSSIBLE_WITH_SELECTED_MARKETING_DATA:
    'LOAN_APPLICATION_POSSIBLE_WITH_SELECTED_MARKETING_DATA',
  LOAN_APPLICATION_POSSIBLE_WITHOUT_SELECTED_MARKETING_DATA:
    'LOAN_APPLICATION_POSSIBLE_WITHOUT_SELECTED_MARKETING_DATA',
  LOAN_APPLICATION_LOWER_PRIVILEGE_LEVEL: 'LOAN_APPLICATION_LOWER_PRIVILEGE_LEVEL',
  USER_HAS_LESS_THAN_3000_PRELIMIT: 'USER_HAS_LESS_THAN_3000_PRELIMIT',
  USER_HAS_NO_ACTIVE_ACCOUNT: 'USER_HAS_NO_ACTIVE_ACCOUNT',
  USER_HAS_0_PRELIMIT: 'USER_HAS_0_PRELIMIT',
  PRAGMA_PROCESS_IFRAME: 'PRAGMA_PROCESS_IFRAME',
} as const;

export const VIEW_TYPE = {
  APP_LOADING: 'APP_LOADING',
  DASHBOARD: 'DASHBOARD',
  LOAN_FORM_VIEW: 'LOAN_FORM_VIEW',
  SELECT_OFFER_VIEW: 'SELECT_OFFER_VIEW',
  PLAYGROUND: 'PLAYGROUND',
  ...ZERO_VIEW_TYPE,
} as const;

export type ViewType = (typeof VIEW_TYPE)[keyof typeof VIEW_TYPE];
export type ViewTypes = typeof VIEW_TYPE;

export type ZeroViewType = Extract<
  ViewType,
  | ViewTypes['SERVICE_NOT_AVAILABLE']
  | ViewTypes['LOAN_APPLICATION_POSSIBLE_WITH_SELECTED_MARKETING_DATA']
  | ViewTypes['LOAN_APPLICATION_POSSIBLE_WITHOUT_SELECTED_MARKETING_DATA']
  | ViewTypes['LOAN_APPLICATION_LOWER_PRIVILEGE_LEVEL']
  | ViewTypes['USER_HAS_LESS_THAN_3000_PRELIMIT']
  | ViewTypes['USER_HAS_NO_ACTIVE_ACCOUNT']
  | ViewTypes['USER_HAS_0_PRELIMIT']
  | ViewTypes['PRAGMA_PROCESS_IFRAME']
>;
